import { call, fork, put } from 'redux-saga/effects';
import { photoCaptureDataFailureAction, photoCaptureGetContextDataSuccessAction, photoCaptureIntelligentPostPrtcDetailsRequestAction } from '../actions';
import { PhotoCaptureContextService } from '../services';
import { attachmentInfo, getErrorMessagesBasedOnStatusCode } from '../utilities';
import { intelligentPhotoCaptureFailureLoggingSaga } from './intelligentPhotoCaptureFailureLoggingSaga';
export function* photoCaptureGetContextSaga(action, photoCaptureContextService = new PhotoCaptureContextService()) {
    const { coCode, contextId } = action.payload;
    try {
        const response = yield call(photoCaptureContextService.photoCaptureGetContextData.bind(photoCaptureContextService), coCode, contextId);
        yield put(photoCaptureGetContextDataSuccessAction(response.result));
        const prtcs = attachmentInfo.extractPrtcCodesFromAttachmentInfo(response.result.attachmentInfo || []);
        if (prtcs.length > 0) {
            yield put(photoCaptureIntelligentPostPrtcDetailsRequestAction({ prtcs }));
        }
    }
    catch (error) {
        const errorMessage = getErrorMessagesBasedOnStatusCode(error);
        // Fire-and-forget error logging so catch-path handling is not blocked.
        yield fork(intelligentPhotoCaptureFailureLoggingSaga, {
            actionType: action.type,
            response: error,
            requestedPayload: action.payload,
            companyCode: coCode,
            errorDetail: errorMessage
        });
        yield put(photoCaptureDataFailureAction(errorMessage));
    }
}
//# sourceMappingURL=photoCaptureGetContextSaga.js.map